import { isPresent } from '../../utils/isPresent';
import { React, Fragment, useState, useRef } from "react";
import ResponsiveMasonry from "react-masonry-css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from "@headlessui/react";
import { Eye, EyeOff, Search, X } from "lucide-react";
import NewSingleCard from "./NewSingleCard";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import CreateBucket from "../CreateBucket";
import { ReactComponent as MySVG } from "../../assets/icons/7601886_top_arrow-update.svg";
import ScrollToTop from "react-scroll-to-top";
import { toastify } from "../../components/Toast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardSkeletonGrid } from "./CardSkeleton";
import ShareCard from "./shareCard";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
import MoveModal from "./includes/MoveModal";
const cardGridBreakpoints = {
  default: 5,
  1535: 4,
  1279: 3,
  1023: 2,
  767: 1,
};
function StarredCard() {
  useRef();
  const isFetchingRef = useRef(false);
  const isPageAdvanceQueuedRef = useRef(false);
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [moveModal, setMoveModal] = useState(false)
  // const [userList, setUserList] = useState([]);
  const [lastList, setLastList] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  useState([]);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [bucketCreated, setBucketCreated] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  const [bucketOperation, ] = useState("Add");

  const [showCopy, setShowCopy] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");


  const [selectedItems, setSelectedItems] = useState([]);
  useState(false);
  let [isOpenss, setIsOpens] = useState(false);
  useOutletContext();
  const [buckets, setBuckets] = useState([]);
  useState("");
  const [clickedCardId, setClickedCardId] = useState(null);
  const [totalCards, setTotalCards] = useState(0);
  const [BucketSharePopup, setBucketSharePopup] = useState(false);
  const [shareBucketId, setShareBucketId] = useState("");
  const [appTheme, setAppTheme] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored === "system" || !stored) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return stored;
  });
  useState(false);


  // Platform and Format filter states
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [showPlatformFilter, setShowPlatformFilter] = useState(false);
  const [showFormatFilter, setShowFormatFilter] = useState(false);
  const bucketId = useParams();

  useEffect(() => {

    const resolveTheme = (val) => {
      if (val === "system" || !val) {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      }
      return val;
    };

    const handleStorageChange = () => {
      setAppTheme(resolveTheme(localStorage.getItem("theme")));
    };

    window.addEventListener('storage', handleStorageChange);
    setAppTheme(resolveTheme(localStorage.getItem("theme")));

    // Listen for OS theme changes when in "system" mode
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleSystemChange = () => {
      const stored = localStorage.getItem("theme");
      if (stored === "system" || !stored) {
        setAppTheme(mediaQuery.matches ? "dark" : "light");
      }
    };
    mediaQuery.addEventListener("change", handleSystemChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      mediaQuery.removeEventListener("change", handleSystemChange);
    };
  }, []);



  function closeCardModal() {
    setIsOpens(false);
  }
  const closeSharePop = () => {
    setBucketSharePopup(false);
  };
  const handleSharePop = (id) => {
    setShareBucketId(id);
    setBucketSharePopup(true);
  };
  const filterDropDown = [
    { name: "Created Date", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
    // { name: 'Manual', href: '#' },
  ];

  // Platform and Format filter options
  const platformOptions = [
    { name: "Instagram", value: "instagram" },
    { name: "Facebook", value: "facebook" },
    { name: "TikTok", value: "TikTok" },
    { name: "Twitter", value: "twitter" },
    { name: "YouTube", value: "youtube" }
  ];

  const formatOptions = [
    { name: "Video", value: "Video" },
    { name: "Image", value: "Image" },
    { name: "Carousel", value: "Carousel" }
  ];

  let cardFilterv = "";
  const savedCardFilter = localStorage.getItem("cardFilter");
  const hasMigratedToCreatedDateDefault = localStorage.getItem("cardFilterCreatedDateDefaultMigrated") === "true";
  if (!savedCardFilter || (savedCardFilter === "Recent_Activity" && !hasMigratedToCreatedDateDefault)) {
    localStorage.setItem("cardFilter", "Created_Date");
    cardFilterv = "Created_Date";
  } else {
    cardFilterv = savedCardFilter;
  }
  if (!hasMigratedToCreatedDateDefault) {
    localStorage.setItem("cardFilterCreatedDateDefaultMigrated", "true");
  }
  const [cardFilterDefault, setCardFilterDefault] = useState(cardFilterv);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  useEffect(() => {
    if (lastList || prevPage === currPage || isFetchingRef.current) return;

    const controller = new AbortController();

    const fetchData = async () => {
      const token = localStorage.getItem("token");

      isFetchingRef.current = true;
      isPageAdvanceQueuedRef.current = false;
      setIsLoadings(true);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}cards/list`,
          {
            filterValue: cardFilterDefault, page: currPage, limit: 10,
            "platform": selectedPlatforms,
            "format": selectedFormats
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
          }
        );

        if (controller.signal.aborted) return;

        setIsLoading(false);
        const newCards = response.data.data.cardsList;
        if (!newCards.length) {
          setLastList(true);
          return;
        }

        setPrevPage(currPage);
        setCardList((currentCards) => {
          if (currPage === 1) return newCards;

          const existingIds = new Set(currentCards.map((card) => card._id));
          return [...currentCards, ...newCards.filter((card) => !existingIds.has(card._id))];
        });
        setTotalCards(response.data.data.totalCards);
      } catch (error) {
        if (!controller.signal.aborted) console.error(error);
      } finally {
        if (!controller.signal.aborted) {
          isFetchingRef.current = false;
          setIsLoadings(false);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
      isFetchingRef.current = false;
    };
  }, [
    bucketCreated,
    cardCreated,
    currPage,
    lastList,
    prevPage,
    selectedPlatforms,
    selectedFormats,
    cardFilterDefault,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      if (
        !lastList &&
        !isFetchingRef.current &&
        !isPageAdvanceQueuedRef.current &&
        parseInt(scrollTop) + parseInt(clientHeight) >=
        parseInt(scrollHeight) - 100
      ) {
        isPageAdvanceQueuedRef.current = true;
        setCurrPage((page) => page + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastList]);
  const handleCardClick = (cardId) => {
    setClickedCardId(cardId);
  };
  useEffect(() => {
  }, [clickedCardId]);




  // const [filtersText, setFiltersText] = useState(filterDropDown[0].name);
  const [filtersText, setFiltersText] = useState(
    cardFilterv === "Created_Date"
      ? filterDropDown[0].name
      : cardFilterv === "Descending_Order"
        ? filterDropDown[3].name
        : cardFilterv === "Ascending_Order"
          ? filterDropDown[2].name
          : cardFilterv === "Recent_Activity"
            ? filterDropDown[1].name
            : ""
  );

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };

  const MoveCard = async () => {
    setMoveModal(true)
    setOpenMove(true);
  };

  const closeMove = () => {
    // setIsBucketOpen(false);
    // setSelectedItems("")
    setSelectedItems([])
    setMoveModal(false)
    setOpenMove(false);
    // setselectedBucketId("");
    // setSearchBucket("");
  };
  const deleteCard = async () => {
    setIsOpens(true);
  };

  const handleDeleteCard = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      closeCardModal();
      cardUpdate();
    } catch (error) {
      console.error(error);
      closeCardModal();
      setIsLoading(false);
      toastify("error", error.response.data.message);
    }
  };

  const handleFilterText = async (text) => {
    // setFiltersText(text);
    setIsLoading(true);
    setFiltersText(text);
    const filterValues =
      text === "Created Date"
        ? "Created_Date"
        : text === "Descending Order"
          ? "Descending_Order"
          : text === "Ascending Order"
            ? "Ascending_Order"
            : text === "Recent Activity"
              ? "Recent_Activity"
              : "";
    localStorage.setItem("cardFilter", filterValues);
    setCardFilterDefault(filterValues);
    localStorage.getItem("token");
    cardUpdate();
  };

  // Platform filter handlers
  const handlePlatformChange = (platformValue) => {
    setSelectedPlatforms(prev => {
      if (prev.includes(platformValue)) {
        return prev.filter(p => p !== platformValue);
      } else {
        return [...prev, platformValue];
      }
    });
    cardUpdate();
  };





  const handlePlatformFilterClick = (e) => {
    e.preventDefault();
    setShowPlatformFilter(!showPlatformFilter);
    setShowFormatFilter(false); // Close other filter
  };

  // Format filter handlers
  const handleFormatChange = (formatValue) => {
    setSelectedFormats(prev => {
      if (prev.includes(formatValue)) {
        return prev.filter(f => f !== formatValue);
      } else {
        return [...prev, formatValue];
      }
    });
    cardUpdate();
  };





  const handleFormatFilterClick = (e) => {
    e.preventDefault();
    setShowFormatFilter(!showFormatFilter);
    setShowPlatformFilter(false); // Close other filter
  };

  // Close filters when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.platform-filter') && !event.target.closest('.format-filter')) {
        setShowPlatformFilter(false);
        setShowFormatFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const bucketNav = [
    { icon: faTrash, name: "Select All", href: "#" },
    { icon: faTrash, name: "Unselect All", href: "#" },
    // { icon: faPencil, name: "Edit Name", href: "#" },
    // { icon: faNoteSticky, name: "Create New Card", href: "#" },
    // { icon: faTrash, name: "Delete", href: "#" },
    // { icon: faFolder, name: "Customize New Card", href: "#" },
  ];


  const handleAllCardClick = (text) => {
    if (text === "Select All") {
      setSelectedItems(cardList.map((card) => card._id));
    } else if (text === "Unselect All") {
      setSelectedItems([]);
    }
  };








  function cardUpdate() {
    // setBucketCreated(true);
    setLastList(false);
    setCurrPage(1);
    setPrevPage(0);
    setCardList([]);
    setCardCreated(!cardCreated);
  }

  const handleStarredChange = (cardId, starred) => {
    setCardList((cards) =>
      cards.map((card) =>
        card._id === cardId ? { ...card, starred } : card
      )
    );
  };

  const handleTitleChange = (cardId, title) => {
    setCardList((cards) =>
      cards.map((card) => card._id === cardId ? { ...card, title } : card)
    );
  };

  function bucketUpdate() {
    // setBucketCreated(true);
    setBucketCreated(!bucketCreated);
  }



  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="subBuckets-whole listingCards responsive-page responsive-page--all-cards">
          <div className="cards">
            <div className="subbucketheaderdesktop-section">
              {/* New Header Design */}
              <div className="all-cards-toolbar flex items-center justify-between mb-8">
                <div className="all-cards-toolbar__primary flex items-center gap-3">
                  <h1 className={`text-3xl font-bold tracking-tight ${appTheme === "dark" ? "text-white" : "text-gray-900"}`}>
                    All Cards
                  </h1>
                  <span className={`rounded-full px-3 py-1 text-sm font-medium ${appTheme === "dark" ? "bg-white/5 text-gray-300" : "bg-gray-100 text-gray-700"}`}>
                    {totalCards}
                  </span>

                  {BucketSharePopup && (
                    <div
                      className="filesuploadpopup relative !z-[999]"
                      style={{ height: "100%" }}
                      onClick={closeSharePop}
                    >
                      <div
                        className="subinviteupload-section"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="teaminvitesection flex">
                          <div className="teammembers-content">Share</div>
                          <div
                            className="dismissSubfiles-content"
                            onClick={closeSharePop}
                          >
                            <img src={BlackDismiss} alt="dismissButton" />
                          </div>
                        </div>
                        <ShareCard
                          shareBucketId={shareBucketId}
                          closeSharePop={closeSharePop}
                          cardsRefresh={cardUpdate}
                        />
                      </div>
                    </div>
                  )}

                  {/* Three-dots menu (Select All / Unselect All) */}
                  <Menu as="div" className="relative">
                    <Menu.Button className={`rounded-xl h-9 w-9 flex items-center justify-center transition-all duration-200 ${appTheme === "dark" ? "text-gray-400 hover:text-white hover:bg-white/5" : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1" /><circle cx="12" cy="5" r="1" /><circle cx="12" cy="19" r="1" /></svg>
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className={`absolute left-0 z-10 mt-2 w-48 origin-top-left rounded-xl py-1 shadow-lg ring-1 focus:outline-none ${appTheme === "dark" ? "bg-[#1a1a1a] ring-white/10" : "bg-white ring-black/5"}`}>
                        {bucketNav.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <button type="button" data-former-link=""

                                className={classNames(
                                  active ? (appTheme === "dark" ? "bg-white/5" : "bg-gray-100") : "",
                                  `block py-2 px-4 text-sm ${appTheme === "dark" ? "text-gray-300" : "text-gray-700"}`
                                )}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleAllCardClick(item.name);
                                }}
                              >
                                <span className="pr-2">
                                  <FontAwesomeIcon
                                    className={appTheme === "dark" ? "text-gray-500" : "text-[#797979]"}
                                    icon={item.icon}
                                  />
                                </span>
                                <span>{item.name}</span>
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>

                  {/* Static Search Bar */}
                  <div className="all-cards-search relative ml-2">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500 z-10" />
                    <input
                      type="text"
                      placeholder="Search cards..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className={`w-[300px] pl-9 pr-9 h-10 rounded-xl border outline-none transition-all duration-200 ${appTheme === "dark"
                        ? "bg-white/5 border-white/10 text-white placeholder:text-gray-500 focus:bg-white/10"
                        : "bg-white border-gray-200 text-gray-900 placeholder:text-gray-400"
                        }`}
                    />
                    {searchQuery.length > 0 && (
                      <button
                        onClick={() => setSearchQuery("")}
                        className={`absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 rounded-full flex items-center justify-center transition-all duration-200 ${appTheme === "dark"
                          ? "text-gray-400 hover:text-white hover:bg-white/10"
                          : "text-gray-500 hover:text-gray-900 hover:bg-gray-100"
                          }`}
                      >
                        <X className="h-3.5 w-3.5" />
                      </button>
                    )}
                  </div>
                </div>

                {/* Right side â€” filters */}
                <div className="all-cards-toolbar__filters flex items-center gap-2">
                  {/* Platform Filter */}
                  <div className="platform-filter relative">
                    <button
                      onClick={handlePlatformFilterClick}
                      className={`gap-2 h-10 px-4 rounded-xl border transition-all duration-200 flex items-center ${appTheme === "dark" ? "bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white" : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"}`}
                    >
                      <span className="text-sm font-medium">Platform ({selectedPlatforms.length})</span>
                      <FontAwesomeIcon style={{ fontSize: "12px" }} icon={faChevronDown} />
                    </button>
                    {showPlatformFilter && (
                      <div className={`absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl py-1 shadow-lg ring-1 focus:outline-none ${appTheme === "dark" ? "bg-[#111111] ring-white/10" : "bg-white ring-black/5"}`}>
                        {platformOptions.map((platform) => (
                          <button
                            key={platform.value}
                            onClick={() => handlePlatformChange(platform.value)}
                            className={`w-full flex items-center justify-between px-4 py-2.5 text-sm rounded-lg cursor-pointer transition-colors ${appTheme === "dark" ? "text-white hover:bg-white/5" : "text-gray-900 hover:bg-gray-100"}`}
                          >
                            <span>{platform.name}</span>
                            {selectedPlatforms.includes(platform.value) && (
                              <FontAwesomeIcon icon={faCheck} className="text-orange-500 text-sm" />
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Format Filter */}
                  <div className="format-filter relative">
                    <button
                      onClick={handleFormatFilterClick}
                      className={`gap-2 h-10 px-4 rounded-xl border transition-all duration-200 flex items-center ${appTheme === "dark" ? "bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white" : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"}`}
                    >
                      <span className="text-sm font-medium">Format ({selectedFormats.length})</span>
                      <FontAwesomeIcon style={{ fontSize: "12px" }} icon={faChevronDown} />
                    </button>
                    {showFormatFilter && (
                      <div className={`absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl py-1 shadow-lg ring-1 focus:outline-none ${appTheme === "dark" ? "bg-[#111111] ring-white/10" : "bg-white ring-black/5"}`}>
                        {formatOptions.map((format) => (
                          <button
                            key={format.value}
                            onClick={() => handleFormatChange(format.value)}
                            className={`w-full flex items-center justify-between px-4 py-2.5 text-sm rounded-lg cursor-pointer transition-colors ${appTheme === "dark" ? "text-white hover:bg-white/5" : "text-gray-900 hover:bg-gray-100"}`}
                          >
                            <span>{format.name}</span>
                            {selectedFormats.includes(format.value) && (
                              <FontAwesomeIcon icon={faCheck} className="text-orange-500 text-sm" />
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Sort By */}
                  <Menu as="div" className="relative flex-shrink-0">
                    <Menu.Button className={`gap-2 h-10 px-4 rounded-xl border transition-all duration-200 flex items-center ${appTheme === "dark" ? "bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white" : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"}`}>
                      <span className="text-sm font-medium">{filtersText}</span>
                      <FontAwesomeIcon style={{ fontSize: "12px" }} icon={faChevronDown} />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className={`absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl py-1 shadow-lg ring-1 focus:outline-none ${appTheme === "dark" ? "bg-[#111111] ring-white/10" : "bg-white ring-black/5"}`}>
                        {filterDropDown.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <a
                                onClick={() => handleFilterText(item.name)}
                                href={item.href}
                                className={classNames(
                                  active ? (appTheme === "dark" ? "bg-white/5" : "bg-gray-100") : "",
                                  `block py-2.5 px-4 text-sm rounded-lg ${appTheme === "dark" ? "text-gray-300" : "text-gray-700"}`
                                )}
                              >
                                {item.name}
                              </a>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>

                  {/* Show Copy Toggle */}
                  <button
                    className={`gap-2 h-10 px-4 rounded-xl border transition-all duration-200 flex items-center ${showCopy
                      ? appTheme === "dark"
                        ? "bg-white/10 text-white hover:bg-white/15 border-white/10"
                        : "bg-gray-100 text-gray-900 hover:bg-gray-200 border-gray-200"
                      : appTheme === "dark"
                        ? "bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white border-white/10"
                        : "bg-white text-gray-500 hover:bg-gray-50 border-gray-200"
                      }`}
                    onClick={() => setShowCopy(!showCopy)}
                  >
                    {showCopy ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
                    <span className="text-sm font-medium">Show Copy</span>
                  </button>
                </div>
              </div>

              {/* Selection Bar â€” visible when cards are selected */}
              {selectedItems.length > 0 && (
                <div className={`all-cards-selection mb-6 rounded-2xl p-4 flex items-center justify-between backdrop-blur-sm ${appTheme === "dark" ? "bg-orange-500/10 border border-orange-500/30" : "bg-orange-50 border border-orange-200"}`}>
                  <div className="flex items-center gap-3">
                    <span className={`text-sm font-semibold ${appTheme === "dark" ? "text-white" : "text-gray-900"}`}>
                      {selectedItems.length} card{selectedItems.length !== 1 ? "s" : ""} selected
                    </span>
                    <button
                      className={`h-8 px-3 text-sm rounded-lg transition-colors ${appTheme === "dark" ? "text-gray-400 hover:text-white hover:bg-white/5" : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"}`}
                      onClick={() => handleAllCardClick("Unselect All")}
                    >
                      Clear selection
                    </button>
                    <div className={`h-4 w-px ${appTheme === "dark" ? "bg-white/10" : "bg-gray-200"}`} />
                    <button
                      className={`h-8 px-3 text-sm rounded-lg border transition-colors ${appTheme === "dark" ? "bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white" : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"}`}
                      onClick={MoveCard}
                    >
                      Move to...
                    </button>
                  </div>
                  <button
                    className="h-8 px-4 text-sm bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
                    onClick={() => deleteCard()}
                  >
                    Delete selected
                  </button>
                </div>
              )}

              {/* Delete Confirmation Modal */}
              <Transition appear show={isOpenss} as={Fragment}>
                <Dialog
                  as="div"
                  className="relative z-10"
                  onClose={closeCardModal}
                >
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                          <Dialog.Title
                            as="h3"
                            className="text-lg font-medium leading-6 text-gray-900"
                          >
                            Delete
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Are you sure you want to delete?
                            </p>
                          </div>
                          <div className="mt-4">
                            <button
                              style={{
                                background: "#FF6600",
                                width: "80px",
                                color: "#fff",
                                padding: "10px",
                                borderRadius: "50px",
                              }}
                              type="button"
                              className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium"
                              onClick={() => handleDeleteCard()}
                            >
                              Yes
                            </button>
                            <button
                              style={{
                                background: "#000",
                                width: "80px",
                                color: "#fff",
                                padding: "10px",
                                borderRadius: "50px",
                              }}
                              type="button"
                              className="ml-4 inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium"
                              onClick={closeCardModal}
                            >
                              No
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>

              {/* Card Grid Iteration */}
              <div className="mansorydesktop-section">
                <ResponsiveMasonry
                  breakpointCols={cardGridBreakpoints}
                  className="card-masonry flex -ml-4 w-auto"
                  columnClassName="card-masonry__column pl-4 bg-clip-padding"
                >
                  {cardList?.map((card) => {
                    const sharedWithObjects = card?.shared
                      ? card.shared
                        .filter(shares => isPresent(shares.sharedWith))
                        .map(shares => shares.sharedWith)
                      : [];
                    return (
                      <div key={card._id} className="w-full inline-block break-inside-avoid mb-[-3px]" style={{ contain: 'inline-size' }}>
                        <NewSingleCard
                          selectedItems={selectedItems}
                          handleSharePop={handleSharePop}
                          starred={card.starred}
                          buckets={buckets}
                          cardUpdate={cardUpdate}
                          cardId={card._id}
                          cardType={card.cardType}
                          sharedBy={[]}
                          sharedUsers={sharedWithObjects}
                          sharedLength={card.shared.length}
                          title={card.title}
                          content={card.content}
                          note={card.note}
                          tags={card.tags}
                          postDetail={card.postDetail ? card.postDetail : ""}
                          updated={card.updatedAt}
                          handleCheckboxChange={handleCheckboxChange}
                          handleCardClick={handleCardClick}
                          adData={card.adData}
                          aiData={card.content?.extractedData || null}
                          showCopy={showCopy}
                          onStarredChange={handleStarredChange}
                          onTitleChange={handleTitleChange}
                        />
                      </div>
                    );
                  })}
                </ResponsiveMasonry>
                {isLoadings && <CardSkeletonGrid />}
              </div>
            </div>
          </div>
        </div>
      )}
      {popup === true ? (
        <CreateBucket
          bucketUpdate={bucketUpdate}
          bucketOperation={bucketOperation}
          parent={bucketId.id}
          setPopup={setPopup}
        />
      ) : null}
      {moveModal ? <MoveModal openMove={openMove} closeModal={closeMove} selectedItems={selectedItems} cardUpdate={cardUpdate} buckets={buckets} /> : null}
      <ScrollToTop smooth color="#fff" component={<MySVG />} />
      <ToastContainer />
    </>
  );
}

export default StarredCard;
